import I18n from "common/i18n";
import { PieceSort, PieceSortOrder } from "features/builder/pieceList";
import { MapsSortMenu } from "./MapsSortMenu";
import { SidebarSection } from "./SidebarSection";
import { useBuilderSidebar, SidebarToggleButton, SidebarHeaderBand } from "./BuilderSidebar";

const ACCENT = "text-brown-80";

const SORT_OPTIONS: PieceSort[] = [
  PieceSort.DELETED,
  PieceSort.LIKED,
  PieceSort.PLAYED,
  PieceSort.VIEWED,
  PieceSort.REACTION,
];

export const TrashMapsHeader = ({
  count,
  sortAxis,
  sortOrder,
  onChangeSort,
}: {
  count: number;
  sortAxis: PieceSort;
  sortOrder: PieceSortOrder;
  onChangeSort: (axis: PieceSort, order: PieceSortOrder) => void;
}) => {
  const { collapsed, toggle } = useBuilderSidebar();
  return (
    <>
      {collapsed ? (
        <div
          onClick={toggle}
          className="flex-col-el items-center w-full gap-1 py-2 border-0 border-b-2 border-solid border-beige-60 cursor-pointer"
        >
          <SidebarToggleButton />
          <span className="flex-col-center w-10 h-10">
            <span className={`material-symbols-outlined type-md ${ACCENT}`}>delete</span>
          </span>
        </div>
      ) : (
        <SidebarHeaderBand>
          <span className={`material-symbols-outlined type-md ${ACCENT}`}>delete</span>
          <p className="type-text type-body text-textcolor-black whitespace-nowrap">
            {I18n.t("MSG_BUILDER_TRASH_COUNT", { count })}
          </p>
        </SidebarHeaderBand>
      )}

      <SidebarSection icon="swap_vert" labelKey="MSG_BUILDER_SECTION_SORT" accentClass={ACCENT}>
        <MapsSortMenu
          axis={sortAxis}
          order={sortOrder}
          options={SORT_OPTIONS}
          accentTextClass="text-brown-80"
          accentBgClass="bg-brown-80"
          accentBorderClass="border-brown-80"
          onChange={onChangeSort}
        />
      </SidebarSection>
    </>
  );
};
